import { useState } from 'react';
import { CUSTOMIZATION_PANEL_TAB_IDS, type CustomizationPanelTabId } from './constants';

interface IUseCustomizationPanelReturn {
  activeTab: CustomizationPanelTabId,
  setActiveTab: (tab: CustomizationPanelTabId) => void,
}

export const useCustomizationPanel = (): IUseCustomizationPanelReturn => {
  const [activeTab, setActiveTab] = useState<CustomizationPanelTabId>(CUSTOMIZATION_PANEL_TAB_IDS.FILTERS);

  return { activeTab, setActiveTab };
};
